import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Dialog,
  IconButton,
  Box,
  Slide,
  Skeleton,
  TextField,
  InputAdornment,
  Button,
  Fab,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import GroupsIcon from "@mui/icons-material/Groups";
import AttachFileIcon from "@mui/icons-material/AttachFile"; // Media Icon
import CloseIcon from "@mui/icons-material/Close";
import { WhatsappTemplatesAPI } from "../../../../api/Endpoints/WhatsappTemplateAPI";
import TemplateSuccess from "../../../../containers/TemplateSuccess";
import TemplatePreviewer from "./TemplatePreviewer/TemplatePreviewer";

function MultiTemplateSender({
  open,
  setOpen,
  totalSelected,
  setTemplateData,
  selectedChats,
  TableUpdate,
  setSelectedChats,
  watch,
  setSelectedRow,
  setSearchEntry,
  onMultiSendTriggered // New prop to notify when multisend is triggered
}) {
  const handleClose = () => setOpen(false);

  const [sucess, setSucess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [templateContent, setTemplateContent] = useState("");
  const [previewrOpen, setPreviewrOpen] = useState(false);
  const [allTemplates, setAllTemplates] = useState([]);

  useEffect(() => {
    if (open) {
      fetchTemplates();
    }
  }, [open]);

  const fetchTemplates = async () => {
    setLoading(true);
    const res = await WhatsappTemplatesAPI.get();
    setData(res?.data?.data?.data);
    setAllTemplates(res?.data?.data?.data);
    setLoading(false);
  };

  const showTemplatePreview = (data) => {
    setTemplateContent(data);
  };
  
  const onSend = async (e) => {
    setLoadingBtn(true);
    setLoading(true);
    const MessageText =
      templateContent.components &&
      templateContent.components.find((comp) => comp.type === "BODY")?.text;
    const headerType =
      templateContent.components &&
      templateContent.components.find((comp) => comp.type === "HEADER")?.format;
    setTemplateData(templateContent);
    const Message = {
      lead_ids: selectedChats.map((item) => item?.lead_id || item),
      template_name: templateContent.name,
      language: "en_US",
      message: MessageText,
      ...(headerType ? { header: [headerType.toLowerCase()] } : {}),
      header_type: headerType?.toLowerCase(),
      to: selectedChats.map((item) => item.phone_number),
      media: selectedMedia, // Include media if selected
      parameter_format: "POSITIONAL",
    };
    
    try {
      // First trigger the API call
      const response = await WhatsappTemplatesAPI.SendMultiSendTemplate(Message);
      
      // Only notify parent that multisend has been triggered AFTER successful API call
      if (onMultiSendTriggered) {
        onMultiSendTriggered();
      }
      
      setLoadingBtn(false);
      setTemplateContent("");
      setSucess(true);
      setLoading(false);
      setSelectedChats&& setSelectedChats([]);
      setSelectedRow&& setSelectedRow([]);
      setSearchEntry&& setSearchEntry('');
      TableUpdate();
      
      setTimeout(() => {
        setSucess(false);
        setOpen(false);
      }, 4000);
    } catch (error) {
      console.error("Error sending bulk messages:", error);
      setLoadingBtn(false);
      setLoading(false);
      // Still close the dialog even if there's an error
      setTimeout(() => {
        setOpen(false);
      }, 4000);
    }
  };

  // Media Selection Handler
  const handleMediaSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedMedia(file);
    }
  };

  return (
    <>
      <Dialog
        open={open}
        PaperProps={{
          sx: {
            width: "50%",
            height: "100%",
            position: "fixed",
            right: 0,
            top: 0,
            bottom: 0,
            m: 0,
            p: 0,
            borderRadius: 0,
            maxHeight: "100%",
            display: "flex",
            flexDirection: "column",
          },
        }}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        {sucess ? (
          <TemplateSuccess onBack={handleClose} />
        ) : (
          <Container maxWidth="sm" sx={{ py: 3 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                variant="h6"
                sx={{ display: "flex", alignItems: "center", gap: 1 }}
              >
                <GroupsIcon /> {totalSelected} People Selected
              </Typography>
              <IconButton onClick={handleClose}>
                <ArrowBackIcon />
              </IconButton>
            </div>

            <TextField
              fullWidth
              label="Search Template"
              variant="outlined"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              sx={{ mt: 5, mb: 3 }}
              InputProps={{
                endAdornment: searchTerm && (
                  <InputAdornment position="end">
                    <IconButton size="small" onClick={() => setSearchTerm("")}>
                      <CloseIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            {loading ? (
              [...Array(8)].map((_, index) => (
                <Skeleton
                  key={index}
                  variant="rectangular"
                  width={550}
                  height={100}
                  sx={{ borderRadius: 2, marginBottom: 2 }}
                />
              ))
            ) : data?.length > 0 ? (
              data.map((template) => (
                <Button
                  disabled={loadingBtn}
                  onClick={() => showTemplatePreview(template)}
                  key={template.name}
                  variant="outlined"
                  sx={{
                    borderLeft: `4px solid`,
                    cursor: "pointer",
                    mb: 2,
                    borderRadius: 10,
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{ display: "flex", alignItems: "center", gap: 1 }}
                  >
                    {template.name} <ArrowForwardIcon fontSize="small" />
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {template.description}
                  </Typography>
                </Button>
              ))
            ) : (
              <Typography
                variant="h6"
                color="text.secondary"
                sx={{ textAlign: "center", mt: 3 }}
              >
                No Templates Found
              </Typography>
            )}

            {/* Floating Media Upload Button */}
            {/* <input
            type="file"
             accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
            style={{ display: "none" }}
            id="media-upload"
            onChange={handleMediaSelect}
          />
          <label htmlFor="media-upload">
            <Fab
              color="primary"
              aria-label="attach media"
              sx={{
                position: "fixed",
                bottom: 16,
                right: 16,
              }}
              component="span"
            >
              <AttachFileIcon />
            </Fab>
          </label> */}

            {/* Show selected media file name */}
            {selectedMedia && (
              <Typography variant="body2" sx={{ mt: 2, textAlign: "center" }}>
                Selected: {selectedMedia.name}
              </Typography>
            )}
          </Container>
        )}
      </Dialog>
      <TemplatePreviewer
        onSend={onSend}
        open={templateContent}
        setOpen={setTemplateContent}
        templateContent={templateContent}
        loading={loading}
      />
    </>
  );
}

export default MultiTemplateSender;